import DatosJuicio from "../domain/DatosJuicio"
import { formatearFechaLuxon } from "../../utils/formatearFecha"
import Juicio from "../domain/Juicio"
import ApiServiceAdapter from "../infraestructure/ApiServiceAdapter"
import PericiaJuicio from "../domain/PericiaJuicio"
import SentenciaJuicio from "../domain/SentenciaJuicio"
import CartaJuicio from "../domain/CartaJuicio"

class JuicioServices {
  constructor(cuitLetrado, nroSiniestro, caratula, idJuicio, fechaNotificacionInicio, fechaNotificacionFin, nroRaj, idEstadoJuicio) {
    this.apiService = new ApiServiceAdapter()
    this.cuitLetrado = cuitLetrado
    this.nroSiniestro = nroSiniestro 
    this.caratula = caratula
    this.idJuicio = idJuicio
    this.fechaNotificacionInicio = fechaNotificacionInicio
    this.fechaNotificacionFin = fechaNotificacionFin
    this.nroRaj = nroRaj
    this.idEstadoJuicio = idEstadoJuicio
  }

  async getJuicios() {

    const idjuicio = this.idJuicio == -1 || this.idJuicio === undefined ? "" : this.idJuicio
    const cuit = this.cuitLetrado ?? "";

    const juicioData = await this.apiService.fetchJuicios(cuit, this.nroSiniestro, this.caratula, idjuicio)

    const listadoJuicios = juicioData &&
      juicioData.map((juicio) => new Juicio(
        juicio.idJuicio,
        formatearFechaLuxon(juicio.fechaNotificacion, "dd/MM/yyyy"),
        juicio.caratula,
        juicio.expediente,
        juicio.nroSiniestro,
        juicio.tipoJuicio,
        juicio.idDenuncia,
        null,
        null,
        null
      )
      )

    return listadoJuicios
  }
  async obtenerDatosJuicio(idJuicio) {

    const juicioData = await this.apiService.fetchDatosJuicio(idJuicio)

    const juicio = juicioData && new DatosJuicio(
      juicioData[0].juicio,
      juicioData[0].denuncia,
      juicioData[0].caratula,
      juicioData[0].nombreCompleto,
      juicioData[0].idLetradoCia,
      juicioData[0].nroSiniestro,
      juicioData[0].estadoJuicio,
      juicioData[0].descripcion,
      juicioData[0].patologia,
      juicioData[0].capitalDeman,
      juicioData[0].porcionRecla,
      juicioData[0].jusrisdiccion,
      juicioData[0].tipo,
      juicioData[0].estudioExt,
      juicioData[0].ibm
    )

    return juicio
  }

  async obtenerDatosPericiaJuicio(idJuicio) {
    try {
      const juicioPericiaData = await this.apiService.fetchDatosPericiaJuicio(idJuicio)

      const listadoPericiasJuicios = Array.isArray(juicioPericiaData)
        ? juicioPericiaData.map((juicio) => new PericiaJuicio(juicio))
        : []

      return listadoPericiasJuicios
    } catch (error) {
      console.error("Error obteniendo datos de pericia:", error)
      return []
    }
  }
  async obtenerDatosSentenciaJuicio(idJuicio) {
    try {
      const juicioSentenciaData = await this.apiService.fetchDatosSentenciaJuicio(idJuicio)

      const listadoSentenciasJuicios = Array.isArray(juicioSentenciaData)
        ? juicioSentenciaData.map((juicio) => new SentenciaJuicio(juicio))
        : []

      return listadoSentenciasJuicios
    } catch (error) {
      console.error("Error obteniendo datos de sentencias:", error)
      return []
    }
  }
  async obtenerDatosCartaJuicio(idJuicio) {
    try {
      const juicioCartaData = await this.apiService.fetchDatosCartaJuicio(idJuicio)

      const listadoCartasJuicios = Array.isArray(juicioCartaData)
        ? juicioCartaData.map((juicio) => new CartaJuicio(juicio))
        : []

      return listadoCartasJuicios
    } catch (error) {
      console.error("Error obteniendo datos de sentencias:", error)
      return []
    }
  }

  async getJuiciosReingenieria() {

    const body =
    {
      "pageNumber": 0,
      "pageSize": 0,
      "filters": {
        "fechaNotificacionDesde": formatearFechaLuxon(this.fechaNotificacionInicio, "yyyy-MM-dd"),
        "fechaNotificacionHasta": formatearFechaLuxon(this.fechaNotificacionFin, "yyyy-MM-dd"),
        "letradoCiaCUILCUIT": parseInt(this.cuitLetrado)
      },
      "orderCriteria": {
        "column": "",
        "order": "",
        "value": ""
      }
    }

    if (this.idEstadoJuicio !== -2 && this.idEstadoJuicio !== -1) {
      body.filters.estadoJuicioId = parseInt(this.idEstadoJuicio);
    }

    if (this.nroRaj !== "" && this.nroRaj !== undefined) {
      body.filters.nroRaj = this.nroRaj;
    }

    if (this.idJuicio !== "" && this.idJuicio !== undefined) {
      body.filters.nroJuicio = this.idJuicio;
    }

    if (this.caratula !== "" && this.caratula !== undefined) {
      body.filters.textoBusqueda = this.caratula;
    }    

    const juicioData = await this.apiService.fetchJuiciosReingenieria(body)

    if (!juicioData || !juicioData.succeeded) {
      return null;
    }

    const items = juicioData?.juiciosResponse?.items ?? [];

    const listadoJuicios = items.map(
      (juicio) =>
        new Juicio(
          juicio.nroJuicio,
          formatearFechaLuxon(juicio.fechaNotificacion, "dd/MM/yyyy"),
          juicio.caratula,
          null,
          juicio.nroSiniestro,
          juicio.tipoJuicio,
          null,
          juicio.estado,
          juicio.marcaCritico==="Crítico" ? "SI" : "NO",
          juicio.observacionCritico
        )
    );

    return listadoJuicios
  }

  async getDatosJuicioByIdReingenieria(nroJuicio) {
    const body = {
      "NroJuicio": nroJuicio
    };

    try {
      const juicioData = await this.apiService.fetchJuiciosByIdReingenieria(body);

      if (!juicioData || !juicioData.succeeded) {
        return null;
      }

      return {
        datosJuicio: juicioData.datosJuicioResponse,
        datosSiniestrosJuicio: juicioData.datosSiniestrosJuicioResponse ?? []
      };
    } catch (err) {
      return null;
    }
  }

  
  async getInstruccionesJuicioByIdReingenieria(nroJuicio) {
    try {
      const juicioData = await this.apiService.fetchInstruccionesJuiciosByIdReingenieria(nroJuicio);

      if (!juicioData || !juicioData.succeeded) {
        return null;
      }

      return juicioData.instrucciones

    } catch (err) {
      return null;
    }
  }

}

export default JuicioServices
